// 组件
import { ProBadge } from "../../antd";
import Options from '../subpage/options';
import Operation from '../subpage/operation';
// 方法
import classNames from "classnames";
// 常量
import { ColumnType } from "antd/lib/table";
import { CardColumnType } from "../interface";

/**
 * 生成卡片列
 * @param columns 列配置
 * @param maxHeight 最大高度
 * @param isCount 是否展示角标统计
 * @param dataSource 数据
 * @param onClickOperation 点击操作按钮回调
 * @returns 
 */
function getColumns(
  columns?: CardColumnType[],
  maxHeight?: number,
  isCount?: boolean,
  dataSource?: any[],
  onClickOperation?: (key?: string, record?: any) => void,
): ColumnType<any>[] {
  const newColumns: ColumnType<any>[] = [];
  columns?.forEach((column, columnIndex) => {
    const { title, statue, options, operation, width, cardWidth, cardType = 'default', render, } = column;
    newColumns.push({
      title: isCount ? (
        <ProBadge count={dataSource?.[0]?.[statue]?.length} offset={[10, 0]}>
          {title}
        </ProBadge>
      ) : title,
      width,
      dataIndex: statue,
      key: columnIndex,
      render: (value: any) => {
        if (Array.isArray(value) && value.length) {
          return (
            <div className='card-table-column-wrap' style={maxHeight ? { height: `${maxHeight}px` } : undefined}>
              {
                value.map((item, itemIndex) => {
                  if (render) {
                    return render(statue, item, itemIndex);
                  }
                  const currentCardType = typeof cardType === 'function' ? cardType(statue, item, itemIndex) : cardType;
                  const cardClass = classNames('card-table-column', `card-column-${currentCardType}`)
                  return (
                    <div className='card-table-column-container' key={itemIndex}>
                      <div className={cardClass} style={cardWidth ? { width: `${cardWidth}px` } : undefined}>
                        {
                          !!options && (typeof options === 'function' ? options(statue, item, itemIndex) : <Options statue={statue} record={item} options={options} />)
                        }
                        {
                          !!operation && (typeof operation === 'function' ? operation(statue, item, itemIndex) : <Operation record={item} operation={operation} onClickOperation={onClickOperation} />)
                        }
                      </div>
                    </div>
                  );
                })
              }
            </div>
          );
        }
        return null;
      }
    });
  });
  return newColumns;
}

export default getColumns;
